import { render, staticRenderFns } from "./TableDevices.vue?vue&type=template&id=390c45a8&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TableDevices.vue?vue&type=script&lang=js"
export * from "./TableDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c45a8",
  null
  
)

export default component.exports